module.exports = __webpack_public_path__ + "img/login-user.d6d5f049.png";